import { ComponentInstance } from "@uniformdev/canvas";

import { SideNavCollection } from "@/libraries/design/components/side-nav/src/side-nav-collection/src/side-nav-collection";
import { SideNavCollectionProps } from "@/libraries/design/components/side-nav/src/side-nav-collection/src/side-nav-collection";

import { transformNavItemData } from "../../side-nav-link/src/transform-nav-item-data";

export interface UniformSideNavCollectionProps {
    component: ComponentInstance;
}

const UniformSideNavCollection = ({
    component
}: UniformSideNavCollectionProps) => {
    const slotItems = component.slots?.["sideNavItems"] ?? null;
    if (!slotItems) return;

    const sideNavItems = transformNavItemData(slotItems);
    const props: SideNavCollectionProps = {
        type: "collection",
        collectionName: component.parameters?.["collectionName"]
            ?.value as string,
        sideNavItems: sideNavItems
    };
    return <SideNavCollection {...props} />;
};

export default UniformSideNavCollection;
